import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { firm, resultsDisclaimer } from "../../data/site";
import { SiteLink } from "../SiteLink";
import { VerdictVideo } from "./VerdictVideo";
export function CaseResult() {
  return <section id="case-result" aria-labelledby="result-title" className="on-dark bg-ink text-white" data-id="element-180" data-mp="ijdnmqtlbqbx">
      <div className="page-container verdict-grid" data-id="element-181" data-mp="nd847ldwfp6s">
        <div data-id="element-182" data-mp="sb9jdv87f4cz">
          <p className="eyebrow text-white" data-id="element-183" data-mp="sbje1w471zp0">Featured Case Study</p>
          <h2 id="result-title" className="mt-3 font-extrabold leading-[1.1] tracking-tight" data-id="element-184" data-mp="x9t63xumgk6e">
            Historic $27.5 million jury verdict
          </h2>
          <p className="mt-4 text-[23px] font-bold leading-snug" data-id="element-185" data-mp="11bxxepxll4pv">Michigan’s largest jury verdict for an injured motorcyclist, as reported by the firm</p>
          <p className="mt-2 text-meta text-white/90" data-id="element-186" data-mp="3331d3tmch9ha">Kent County, Michigan · May 3, 2024</p>
          <p className="mt-5 max-w-measure text-meta text-white/80" data-id="element-187" data-mp="381mbdni1dj33">
            The firm’s case report describes it as Michigan’s largest motorcycle injury verdict, based on its research.
          </p>
          <h3 className="mt-7 text-h3 font-bold" data-id="element-188" data-mp="1za6gfz3jq8ou">Holding a distracted driver accountable</h3>
          <p className="mt-4 max-w-measure text-white/90" data-id="element-189" data-mp="1v834l9cyt231">
            A distracted car driver using a phone app crossed the centerline and struck a motorcyclist, whose injuries included a leg amputation.{" "}
            {firm.displayName} represented the rider and his wife, pursuing claims against the driver and her employer.
          </p>
          <SiteLink path="/27-million-motorcycle-injury-verdict/" className="mt-5 inline-flex min-h-[48px] items-center gap-2 text-label font-bold text-white underline underline-offset-4 hover:decoration-2" data-id="element-190" data-mp="2iz8ihizchkap">
            Read the full case study
            <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0" data-id="element-191" data-mp="12jnpynxqwls8" />
          </SiteLink>
          <p className="mt-5 max-w-measure border-t border-white/25 pt-4 text-meta text-white/80" data-id="element-192" data-mp="xkkjr06149io">{resultsDisclaimer}</p>
        </div>
        <VerdictVideo data-id="element-193" data-mp="z1hx7jf42n5g" />
      </div>
    </section>;
}